import { handleSendFunctionResponseToRFPAgent } from "../services/handleSendFunctionResponseToRFPAgent";
import { activateRainbowRing } from "../utilities/rainbowRingFunctions";

export const changeMultipleValues = async (changes, updatedChatSession, documentData, setDocumentData, chatSessionRef, setChatSession, userInfo) => {
    const updatedDocumentData = { ...documentData };
    changes.forEach(change => {
        const { field, new_value } = change;
        updatedDocumentData[field] = new_value;
    })
    setDocumentData(updatedDocumentData);
    const responseMessage = `FunctionResponse: The changes you suggested have been made. Confirm that these are the intended change (silently). If not, run it again. If so, respond letting the user know that the changes have been made successfully and either provide suggestions for further improvement or ask the user how else you can help. Here is the new state of the RFP: ${JSON.stringify(updatedDocumentData, null, 2)}`;
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    };
    activateRainbowRing();
    await handleSendFunctionResponseToRFPAgent(response, updatedChatSession, setChatSession, chatSessionRef, userInfo);
}